// aiSuggest.js
// Utility to fetch AI code suggestions for a given code context

export async function fetchAISuggestion({ code, language, model = 'gpt-4o' }) {
  try {
    const res = await fetch('/api/ai/suggest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, language, model })
    });
    if (!res.ok) throw new Error('Failed to fetch suggestion');
    const data = await res.json();
    return data.suggestion || '';
  } catch (e) {
    return '';
  }
}
